module.exports = __webpack_public_path__ + "static/media/prep-kit-bg.f07995e8.png";